import router from './router'
import { getToken } from '@/utils/auth'
import { checkSystem } from '@/utils/system'
import { autoAppLogin } from '@/utils/judge'

var whiteList = ['/helpCenter', '/download', '/helpContent', '/bind/phone', '/bind/code', '/open', '/register']

router.beforeEach(async(to, from, next) => {
  checkSystem()
  if (whiteList.indexOf(to.path) !== -1) {
    next()
    return false
  } else {
    if (to.path === '/login') {
      var count = sessionStorage.getItem('loginCount')
      if (count) {
        count = parseInt(count)
      }
      if (!count) {
        sessionStorage.setItem('loginCount', 1)
        // 自动登录
        try {
          var autoToken = await autoAppLogin
          if (autoToken) {
            next('/home')
          } else {
            // 自动登录获取token失败
            next('/login')
          }
        } catch (err) {
          next()
        }
      } else if (count <= 2) {
        count = parseInt(count) + 1
        sessionStorage.setItem('loginCount', count)
        // 自动登录
        try {
          autoToken = await autoAppLogin
          if (autoToken) {
            next('/home')
          } else {
            // 自动登录获取token失败
            next('/login')
          }
        } catch (err) {
          next()
        }
      } else {
        next()
      }
    } else {
      var token = getToken()
      if (token && token !== 'undefined') {
        if (to.path === '/login') {
          next('/')
        } else if (to.path === '/') {
          next('/home')
        } else {
          next()
        }
      } else {
        next('/login')
      }
    }
  }
})

router.afterEach((to, from) => {
  document.title = to.meta.title
})
